// ! This file was auto-generated from the k2 OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
import { api } from "~/redux/api/k2/codegenApi";
import { optimisticCreate, optimisticDelete, optimisticUpdate } from "~/redux/api/optimistic-updates";
export const endpoints = {
    archiveWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Workflow,
            idArg: "workflowId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data"
        })
    },
    assignTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "taskAssignRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    bulkReassignTasks: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    cancelPendingDocumentUpload: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    cancelTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "cancelTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    claimTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "taskClaimRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    cloneTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Ticket, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    cloneWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Workflow, id: "LIST" }]
    },
    completeTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    completeTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "completeTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    createAdHocTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticCreate(api, {
            type: Tags.Task,
            responsePath: "data",
            idField: "id",
            listPath: "data",
            synth: {
                bodyArg: "adHocTaskCreateRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    createComment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }, { type: Tags.TicketActions, id: arg.ticketId }],
        onQueryStarted: optimisticCreate(api, {
            type: Tags.Comment,
            responsePath: "data",
            idField: "id",
            listPath: "data",
            synth: {
                bodyArg: "createCommentRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "comments"
            }
        })
    },
    createEsignPackage: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    createTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Ticket, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    createTurn: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    createWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Workflow, id: "LIST" }]
    },
    createWorkflowLocalField: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.WorkflowVersion, id: "LIST" }, { type: Tags.LocalField, id: "LIST" }]
    },
    createWorkflowPermissionBundle: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.PermissionBundle, id: "LIST" }]
    },
    deleteAdHocTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticDelete(api, {
            type: Tags.Task,
            idArg: "taskId",
            idField: "id",
            listPath: "data"
        })
    },
    deleteComment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: arg.commentId }, { type: Tags.Comment, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticDelete(api, {
            type: Tags.Comment,
            idArg: "commentId",
            idField: "id",
            listPath: "data"
        })
    },
    deleteStageAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: arg.stageId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    deleteTaskAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    deleteTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.Ticket, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticDelete(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            idField: "id",
            listPath: "data"
        })
    },
    deleteTicketDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    deleteWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    deleteWorkflowDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    deleteWorkflowFieldOverride: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.WorkflowVersion, id: "LIST" }, { type: Tags.FieldOverride, id: "LIST" }]
    },
    deleteWorkflowPermissionBundle: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.PermissionBundle, id: arg.bundleId }, { type: Tags.PermissionBundle, id: "LIST" }]
    },
    forceUnlockTicketDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    getComment: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: arg.commentId }]
    },
    getContractFamily: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.contract_family_node, id: "LIST" }]
    },
    getCycleTime: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.CycleTime, id: arg.ticketId }]
    },
    getSigningConfiguration: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.SigningConfiguration, id: arg.taskId }]
    },
    getStageAcl: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Stage, id: arg.stageId }]
    },
    getTask: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }]
    },
    getTaskAcl: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }]
    },
    getTicket: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }]
    },
    getTicketActions: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.TicketActions, id: arg.ticketId }]
    },
    getTicketState: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }]
    },
    getTicketVersion: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }]
    },
    getWorkflow: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.WorkflowDocument, id: "LIST" }]
    },
    getWorkflowTemplate: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.WorkflowTemplate, id: arg.templateId }]
    },
    listComments: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    listStages: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Stage, id: "LIST" }]
    },
    listTasks: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Task, id: "LIST" }]
    },
    listThreads: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    listTicketActivityLogs: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ActivityLog, id: "LIST" }]
    },
    listTicketPermissionBundles: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.PermissionBundle, id: "LIST" }]
    },
    listTickets: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Ticket, id: "LIST" }]
    },
    listTurns: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Turn, id: "LIST" }]
    },
    listWorkflowActivityLogs: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ActivityLog, id: "LIST" }]
    },
    listWorkflowFieldOverrides: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.FieldOverride, id: "LIST" }]
    },
    listWorkflowLocalFields: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.LocalField, id: "LIST" }]
    },
    listWorkflowPermissionBundles: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.PermissionBundle, id: "LIST" }]
    },
    listWorkflows: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Workflow, id: "LIST" }]
    },
    listWorkflowTemplates: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.WorkflowTemplate, id: "LIST" }]
    },
    listWorkflowVersions: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.WorkflowVersion, id: "LIST" }]
    },
    livenessCheck: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    patchDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    pauseTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "pauseTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    publishWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    putWorkflowFieldOverride: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.WorkflowVersion, id: "LIST" }, { type: Tags.FieldOverride, id: "LIST" }]
    },
    readinessCheck: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    reassignTicketOwner: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "reassignTicketOwnerRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    recordDocumentShare: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ActivityLog, id: "LIST" }]
    },
    recordSignatures: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Stage, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    recordSignaturesBatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Stage, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    remindTask: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.ActivityLog, id: "LIST" }]
    },
    replaceSigningConfiguration: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.SigningConfiguration, id: arg.taskId }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.SigningConfiguration,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            detailPath: "data",
            synth: {
                bodyArg: "signingConfigurationRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "signing-participants"
            }
        })
    },
    replaceWorkflowDocumentPlaceholderMappings: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.WorkflowDocument,
            idArg: "documentId",
            responsePath: "data",
            idField: "document_id",
            listPath: "data.attributes.workflow_definition.documents"
        })
    },
    requestDocumentUpload: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    requestWorkflowDocumentUpload: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    resetStageTasks: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Stage, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    resetTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "taskResetRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    resolveComment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: arg.commentId }, { type: Tags.Comment, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Comment,
            idArg: "commentId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data"
        })
    },
    resumeTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "resumeTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    retractJudgment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "taskResetRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    retryGeneration: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    retryProcessing: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    scribylLockDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    scribylUnlockDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    searchTickets: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Ticket, id: "LIST" }]
    },
    shareExternally: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    shareInternally: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    submitTicket: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.Ticket, id: "LIST" }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "submitTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    supplierNegotiation: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    transitionToNextStage: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    transitionToStage: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    unarchiveWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Workflow,
            idArg: "workflowId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data"
        })
    },
    unpublishWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Workflow,
            idArg: "workflowId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data"
        })
    },
    unresolveComment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: arg.commentId }, { type: Tags.Comment, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Comment,
            idArg: "commentId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data"
        })
    },
    updateAdHocTask: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "adHocTaskUpdateRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    updateComment: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Comment, id: arg.commentId }, { type: Tags.Comment, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Comment,
            idArg: "commentId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "updateCommentRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "comments"
            }
        })
    },
    updateField: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateFieldsBatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateStageAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Stage, id: arg.stageId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateTaskAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.Task, id: arg.taskId }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateTaskAssociation: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Task, id: arg.taskId }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Task,
            idArg: "taskId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "taskAssociationUpdateRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tasks"
            }
        })
    },
    updateTicketAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateTicketMetadata: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.Stage, id: "LIST" }, { type: Tags.Task, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Ticket,
            idArg: "ticketId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "updateTicketRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "tickets"
            }
        })
    },
    updateTurn: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.Ticket, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    updateWorkflow: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.Workflow,
            idArg: "workflowId",
            responsePath: "data",
            idField: "id",
            listPath: "data",
            detailPath: "data",
            synth: {
                bodyArg: "updateWorkflowRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "workflows"
            }
        })
    },
    updateWorkflowAcl: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    },
    updateWorkflowLocalField: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.WorkflowVersion, id: "LIST" }, { type: Tags.LocalField, id: "LIST" }]
    },
    updateWorkflowPermissionBundle: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.PermissionBundle, id: "LIST" }],
        onQueryStarted: optimisticUpdate(api, {
            type: Tags.PermissionBundle,
            idArg: "bundleId",
            responsePath: "data",
            listPath: "data",
            synth: {
                bodyArg: "updatePermissionBundleRequest",
                dataPath: "data",
                attributesKey: "attributes",
                typeLiteral: "permission-bundle"
            }
        })
    },
    uploadComplete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    versionUpTicketDocument: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Ticket, id: arg.ticketId }, { type: Tags.TicketActions, id: arg.ticketId }, { type: Tags.CycleTime, id: arg.ticketId }, { type: Tags.Turn, id: "LIST" }, { type: Tags.ActivityLog, id: "LIST" }]
    },
    workflowUploadComplete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.Workflow, id: arg.workflowId }, { type: Tags.Workflow, id: "LIST" }, { type: Tags.WorkflowVersion, id: "LIST" }]
    }
} as const;
